import {
    Rubik_400Regular,
    Rubik_500Medium,
    Rubik_700Bold,
    useFonts,
} from '@expo-google-fonts/rubik'
import { NavigationContainer } from '@react-navigation/native'
import { setLogLevel } from 'firebase/app'
import { FC } from 'react'
import { StatusBar } from 'react-native'
import { Provider as PaperProvider } from 'react-native-paper'
import { Provider } from 'react-redux'
import './firebase'
import Navigation from './src/components/Navigation'
import { isDetox } from './src/constants/platform'
import { ScreenEnum } from './src/constants/screen'
import store from './src/redux/store'
import { theme } from './src/styles/theme'

if (!__DEV__ || isDetox) {
    setLogLevel('silent')

    if (!isDetox) {
        console.warn = () => {}
    }
}

const linking = {
    prefixes: ['https://digibon.adaptee.cz'],
    config: {
        screens: {
            [ScreenEnum.Digibon]: '',
            [ScreenEnum.Customer]: ':licenseName/:language/:firebaseToken/customer',
        },
    },
}

const App: FC = () => {
    const [isFontsLoaded] = useFonts({
        Rubik_400Regular,
        Rubik_500Medium,
        Rubik_700Bold,
    })

    if (!isFontsLoaded) {
        return <></>
    }

    return (
        <Provider store={store}>
            <PaperProvider theme={theme}>
                <NavigationContainer linking={linking}>
                    <StatusBar hidden />
                    <Navigation />
                </NavigationContainer>
            </PaperProvider>
        </Provider>
    )
}

export default App
